<form nz-form (ngSubmit)="submitReciboForm()">
  <nz-form-item>
    <nz-form-label [nzSpan]="24" nzFor="numRecibo">Número de Recibo</nz-form-label>
    <nz-form-control [nzSpan]="24" nzErrorTip="Por favor, ingrese un número de recibo válido.">
      <input
        nz-input
        id="numRecibo"
        type="text"
        [(ngModel)]="numRecibo"
        (ngModelChange)="numReciboChange.emit($event)"
        name="numRecibo"
        placeholder="Ingrese el número de recibo"
        required
      />
    </nz-form-control>
  </nz-form-item>
</form>
  <button nz-button nzType="default" (click)="handleCancelReciboModal()">Cancelar</button>
  <button nz-button nzType="primary" [disabled]="!numRecibo" (click)="submitReciboForm()">
    Actualizar
  </button>
